import React from 'react';
import DatePicker from 'react-datepicker';
import {FormLabel} from 'js/form_components';

const InputDatePicker = props => (
    <div>
        <FormLabel
            className={props.className}
            label={props.header}
            helpText={props.help}
            multiline
            inline
            place="right"
        />
        <DatePicker isClearable selected={props.selected} onChange={date => props.onChange(date)} />
    </div>
);

export default InputDatePicker;



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/input_date_picker.js